import licenseModule from '../../license.module';
import template from './licenseUsageDetailResource.component.html';
import style from './licenseUsageDetailResource.component.css';

export default licenseModule.component('licenseUsageDetailResource', {
    template,
    style,
    controller: [
        'alertLevelConstants',
        'doughnutColorConstants',
        licenseUsageDetailResourceComponent
    ],
    bindToController: true,
    bindings: {
        resourceUsage: '<'
    }
});

function licenseUsageDetailResourceComponent(
    alertLevelConstants,
    doughnutColorConstants
) {
    var vm = this;
    vm.$onChanges = render;
    vm.options = {
        showIcon: true
    };

    vm.size = 50;
    vm.value = 10;
    vm.total = 0;
    vm.used = 0;
    vm.remaining = 0;

    function render(changeObj) {
        if (
            changeObj.resourceUsage.currentValue &&
            changeObj.resourceUsage.currentValue != null
        ) {
            vm.total =
                vm.resourceUsage.total == undefined
                    ? 0
                    : vm.resourceUsage.total;
            vm.used =
                vm.resourceUsage.used == undefined ? 0 : vm.resourceUsage.used;
            vm.name = vm.resourceUsage.name;
            vm.color = vm.resourceUsage.color;

            vm.remaining = vm.total - vm.used < 0 ? 0 : vm.total - vm.used;

            vm.percentage = parseFloat((vm.used / vm.total) * 100);
            setProgressBar();
        }
    }

    function setProgressBar() {
        if (!vm.resourceUsage.legacy) {
            if (vm.percentage >= 100) {
                vm.progressType = alertLevelConstants.critical.toLowerCase();
                vm.percentageColor = doughnutColorConstants.red;
            } else if (vm.percentage >= 75) {
                vm.progressType = alertLevelConstants.warning.toLowerCase();
                vm.percentageColor = doughnutColorConstants.yellow;
            } else {
                vm.progressType = alertLevelConstants.none.toLowerCase();
                vm.percentageColor = doughnutColorConstants.blue;
            }
        } else {
            vm.progressType = 'grey';
            vm.percentageColor = doughnutColorConstants.grey;
        }

        vm.percentage =
            vm.percentage > 100 ? '>100' : parseInt(vm.percentage, 10);
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-usage-detail-resource/licenseUsageDetailResource.component.js